<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle title="Students" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row pl-3 pr-3 d-flex justify-content-between">
            <!--  -->
            <a href="javascript:void(0);" class="btn btn-success mb-2"
               (click)="this.customerAddForm.get('mobileNumber').setValue('');openModal(content)">
              <i class="mdi mdi-plus mr-2"></i> Add Student
            </a>
            <div class="">
              <label class="sr-only" for="inlineFormInputGroup">Search</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-search"></i></div>
                </div>
                <input type="text" class="form-control" id="inlineFormInputGroup" placeholder="Search Student..."
                       (input)="onCustomerSearch($event.target.value)">
              </div>
            </div>
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th class="col-3">Email</th>
                <th>Phone</th>
                <th class="col-1">Verified</th>
                <th class="col-1">Training Mode</th>
                <th>Whatsapp</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of customers; let i= index">

                <td>{{i + 1}}</td>
                <td>{{item.customer ? item.customer.userFullName : '-'}}</td>
                <td>{{item.customer ? item.customer.userEmail : '-'}}</td>
                <td>{{item.userPhoneNumber}}</td>
                <td class="col-1">
                  <span class="text-success" *ngIf="item.verified"><i class="fa fa-check"></i></span>
                  <span class="text-danger" *ngIf="!item.verified"><i class="fa fa-times"></i></span>
                </td>
                <td class="col-1">
                  <span class="text-success" *ngIf="item.customer &&item.customer.inTrainingMode"><i
                    class="fa fa-check"></i></span>
                  <span class="text-danger" *ngIf="!item.customer ||!item.customer.inTrainingMode"><i
                    class="fa fa-times"></i></span>
                </td>
                <td><i class="text-success fab fa-whatsapp font-size-24 pointer"
                       matTooltip="Send Whatsapp Message"
                       (click)="onWhatsappMessageClick(item.userPhoneNumber)"></i>
                </td>
                <td>
                  <button mat-button (click)="onResendCodeClick(item)" *ngIf="!item.verified"><a
                    href="javascript:void(0)">Resend Code</a>
                  </button>
                  <div class="dropdown mt-4 mt-sm-0" ngbDropdown *ngIf="item.verified">
                    <a class="btn btn-light " ngbDropdownToggle>
                      Menu <i class="mdi "></i>
                    </a>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      <a class="dropdown-item p-2" href="javascript: void(0);" *ngIf="item.verified"
                         [routerLink]="[item.customer.userId,'trips']"
                         [queryParams]="{customerName:item.customer.userFullName}">Trips</a>
                    </div>
                  </div>

                </td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="customerSearch.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Contacts model  -->
<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Add Student</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="addCustomer()" [formGroup]="customerAddForm">
        <div class="form-group">
          <label>Phone </label>
          <input type="number" class="form-control" placeholder="Enter phone number" formControlName="mobileNumber"
                 [ngClass]="{'is-invalid': submitted && form.mobileNumber.errors}" minlength="10"
                 onkeyup="this.value=this.value.replace(/[^\d]/,'')">
          <div *ngIf="form.mobileNumber.touched && form.mobileNumber.errors" class="invalid-feedback">
            <span *ngIf="form.mobileNumber.errors.required">Phone is mandatory.</span>
            <span *ngIf="form.mobileNumber.errors.minlength">Phone number must be 10 characters.</span>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <button type="button" class="btn btn-danger ml-1 mr-2" (click)="modal('close click')">Cancel</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
